import { Veli } from "@/mocks/veliler";

interface VeliDetayPanelProps {
  veli: Veli;
  onClose: () => void;
}

const sonMesajlar = [
  { tarih: "19 May 2026, 10:32", tip: "Ödeme Hatırlatma", durum: "Gönderildi", icerik: "Merhaba Ayşe Hanım, bu ay ödemeniz 5. günde. Hatırlatmak istedik." },
  { tarih: "12 May 2026, 09:15", tip: "Referans İsteme", durum: "Gönderildi", icerik: "Sayın Ayşe Hanım, memnuniyetinizi çevrenizle paylaşır mısınız?" },
  { tarih: "01 May 2026, 08:00", tip: "Kampanya Duyurusu", durum: "Gönderildi", icerik: "Mayıs ayı kampanyamız başladı! Detaylar için tıklayın." },
];

const planliMesajlar = [
  { tarih: "22 May 2026", tip: "Ödeme Hatırlatma", durum: "Bekliyor" },
  { tarih: "01 Haz 2026", tip: "Referans İsteme", durum: "Planlandı" },
];

export default function VeliDetayPanel({ veli, onClose }: VeliDetayPanelProps) {
  return (
    <div className="fixed inset-0 z-50 flex">
      {/* Overlay */}
      <div className="flex-1 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      {/* Panel */}
      <div className="w-full max-w-[480px] bg-white h-full overflow-y-auto shadow-2xl flex flex-col animate-slide-left">
        {/* Header */}
        <div className="bg-[#0B1120] px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#25D366]/20 border border-[#25D366]/40 flex items-center justify-center">
              <span className="text-[#25D366] text-sm font-bold">
                {veli.veliAdi.split(" ").map((n) => n[0]).join("").slice(0, 2)}
              </span>
            </div>
            <div>
              <p className="text-white font-semibold text-sm">{veli.veliAdi}</p>
              <p className="text-gray-400 text-xs">{veli.ogrenciAdi} · {veli.seviye}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 text-gray-400 hover:text-white cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Quick Actions */}
        <div className="flex gap-2 px-6 py-4 border-b border-gray-100 bg-gray-50/50">
          <a
            href={`https://wa.me/9${veli.telefon.replace(/\s/g, "")}`}
            className="flex-1 flex items-center justify-center gap-1.5 py-2 bg-[#25D366] text-white text-xs font-medium rounded-xl hover:bg-[#1da851] cursor-pointer whitespace-nowrap transition-colors"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-sm"></i>
            </div>
            WhatsApp Aç
          </a>
          <button className="flex-1 flex items-center justify-center gap-1.5 py-2 border border-gray-200 text-gray-700 text-xs font-medium rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-edit-line text-sm"></i>
            </div>
            Düzenle
          </button>
          <button className="flex-1 flex items-center justify-center gap-1.5 py-2 border border-gray-200 text-gray-700 text-xs font-medium rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sticky-note-line text-sm"></i>
            </div>
            Not Ekle
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 px-6 py-5 space-y-6">
          {/* Kişisel Bilgiler */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Kişisel Bilgiler</h3>
            <div className="space-y-3">
              {[
                { icon: "ri-user-line", label: "Veli Adı", value: veli.veliAdi },
                { icon: "ri-graduation-cap-line", label: "Öğrenci Adı", value: veli.ogrenciAdi },
                { icon: "ri-phone-line", label: "Telefon", value: veli.telefon },
                { icon: "ri-book-open-line", label: "Öğrenci Seviyesi", value: veli.seviye },
                { icon: "ri-shield-check-line", label: "Öğrenci Durumu", value: veli.ogrenciDurumu },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 flex-shrink-0">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">{item.label}</p>
                    <p className="text-sm font-medium text-gray-800">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Ödeme & Taahhüt */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Ödeme & Taahhüt</h3>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-amber-50 rounded-xl p-3 border border-amber-100">
                <div className="w-6 h-6 flex items-center justify-center text-amber-500 mb-1.5">
                  <i className="ri-calendar-2-line text-base"></i>
                </div>
                <p className="text-xs text-amber-600">Ödeme Günü</p>
                <p className="text-base font-bold text-amber-700">{veli.odemeGunu}. Gün</p>
              </div>
              <div className="bg-emerald-50 rounded-xl p-3 border border-emerald-100">
                <div className="w-6 h-6 flex items-center justify-center text-emerald-500 mb-1.5">
                  <i className="ri-file-list-3-line text-base"></i>
                </div>
                <p className="text-xs text-emerald-600">Taahhüt Bitiş</p>
                <p className="text-sm font-bold text-emerald-700">{veli.taahhutBitis}</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-3 border border-gray-100 col-span-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400">
                    <i className="ri-calendar-check-line text-base"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Taahhüt Başlangıç</p>
                    <p className="text-sm font-medium text-gray-700">
                      {new Date(new Date(veli.taahhutBitis).setFullYear(new Date(veli.taahhutBitis).getFullYear() - 1)).toLocaleDateString("tr-TR")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Referans Durumu */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Referans Durumu</h3>
            <div className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 bg-gray-50">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                veli.referansDurumu === "Verdi" ? "bg-emerald-100 text-emerald-600" :
                veli.referansDurumu === "Vermedi" ? "bg-red-100 text-red-500" :
                "bg-amber-100 text-amber-600"
              }`}>
                <i className={`text-base ${
                  veli.referansDurumu === "Verdi" ? "ri-user-add-line" :
                  veli.referansDurumu === "Vermedi" ? "ri-user-forbid-line" :
                  "ri-time-line"
                }`}></i>
              </div>
              <div>
                <p className="text-xs text-gray-400">Referans Durumu</p>
                <p className={`text-sm font-semibold ${
                  veli.referansDurumu === "Verdi" ? "text-emerald-600" :
                  veli.referansDurumu === "Vermedi" ? "text-red-500" :
                  "text-amber-600"
                }`}>{veli.referansDurumu}</p>
              </div>
              {veli.referansDurumu !== "Verdi" && (
                <button className="ml-auto px-3 py-1.5 text-xs bg-[#25D366] text-white rounded-lg hover:bg-[#1da851] cursor-pointer whitespace-nowrap transition-colors">
                  Referans İste
                </button>
              )}
            </div>
          </section>

          {/* Notlar */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Notlar</h3>
            <textarea
              placeholder="Bu veli / öğrenci hakkında notlarınızı buraya ekleyin..."
              className="w-full text-sm text-gray-700 border border-gray-200 rounded-xl p-3 resize-none focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-gray-50 h-24"
              defaultValue="Öğrenci matematik derslerinde başarılı. Veli haftalık ilerleme raporu istiyor."
            />
            <button className="mt-2 px-3 py-1.5 text-xs bg-[#0B1120] text-white rounded-lg hover:bg-[#1a2a4a] cursor-pointer whitespace-nowrap transition-colors">
              Notu Kaydet
            </button>
          </section>

          {/* Son Gönderilen Mesajlar */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Son Gönderilen Mesajlar</h3>
            <div className="space-y-2">
              {sonMesajlar.map((m, i) => (
                <div key={i} className="border border-gray-100 rounded-xl p-3 hover:bg-gray-50/50 transition-colors">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-xs font-medium text-gray-700">{m.tip}</span>
                    <span className="text-[10px] px-2 py-0.5 bg-emerald-100 text-emerald-600 rounded-full">{m.durum}</span>
                  </div>
                  <p className="text-xs text-gray-500 leading-relaxed">{m.icerik}</p>
                  <p className="text-[10px] text-gray-400 mt-1.5">{m.tarih}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Planlanan Mesajlar */}
          <section>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Planlanan Mesajlar</h3>
            <div className="space-y-2">
              {planliMesajlar.map((m, i) => (
                <div key={i} className="border border-dashed border-gray-200 rounded-xl p-3 bg-amber-50/30">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 flex items-center justify-center text-amber-500">
                        <i className="ri-time-line text-sm"></i>
                      </div>
                      <span className="text-xs font-medium text-gray-700">{m.tip}</span>
                    </div>
                    <span className="text-[10px] px-2 py-0.5 bg-amber-100 text-amber-600 rounded-full">{m.durum}</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 ml-8">Gönderim tarihi: {m.tarih}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}